import { Dispatch, MouseEventHandler, SetStateAction } from 'react';
import { Cruise } from 'types';

export type SetActiveVariant = Dispatch<SetStateAction<CruiseCardVariant>>;

export enum CruiseCardVariant {
	Refined = 'refined',
	Map = 'map',
}

export interface CruiseCardProps {
	readonly cruise: Cruise;
	readonly listCount?: number;
	readonly listItemIndex?: number;
	readonly variant?: CruiseCardVariant;
	readonly onClick?: MouseEventHandler;
	readonly setActiveVariant?: SetActiveVariant;
	readonly defaultVariant?: CruiseCardVariant;
}

export interface CruiseCardTaggingAttrs {
	id: string;
	'data-selector': number;
	'data-group-id': string;
	'data-package-code': string;
	'data-ship-code': string;
	'data-destination-code': string;
	'data-sail-date': string;
	'data-start-date': string;
	'data-end-date': string;
	'data-first-sail-date': string;
	'data-last-sail-date': string;
	'data-product-view-link': string;
	'data-testid': string;
}

export interface GetDockedTimeRangeParams {
	arrivalTime: string;
	departureTime: string;
	labels: { departs: string; arrival: string; docked: string };
}
